import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAHCiJg5KJ5yHYsu-i1yhxrXD6pc9UP4T4",
  authDomain: "srilavs-doc-ai.firebaseapp.com",
  projectId: "srilavs-doc-ai",
  storageBucket: "srilavs-doc-ai.firebasestorage.app",
  messagingSenderId: "174252338177",
  appId: "1:174252338177:web:723e96feb90c8b72eb2400",
  measurementId: "G-ZG5F8LNFP0"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile, signOut };
